import API from "./API";

export default class Integrations extends API
{
    static async createDiariesIntegrationJob(params) {
        return this.post("api/admin/integrations/diaries/jobs", params);
    }
}